export default __webpack_public_path__ + "static/media/zip.99d9e142.svg";